import BaseContainer from "@base/container/BaseContainer";
import * as PIXI from "pixi.js";
import TweenMax from "gsap"
import { Signals} from "@/Imports";

import Facade from "@/Facade";
import ScaleManager from "@/stage/ScaleManager";
import Config from "@/config/Config";
import brandedVersions from "@/config/BrandedVersions";

export default class SplashScreenContainer extends BaseContainer {

  constructor (data) {
    super(data)
    this.authData = data;
    this.init()
  }

  init() {
    const casinoToken = this.authData['ct'];
    const config = brandedVersions.versions[casinoToken.toLowerCase()] || brandedVersions.versions.default;

    Signals.isMobileDevice.add(this.onMobileDevice, this)

    const back = new PIXI.Graphics()
    back.beginFill(config.splashScreenBackgroundColor)
    back.drawRect(0, -300, ScaleManager.currentSizes.total.width, ScaleManager.currentSizes.total.height + 600)
    back.endFill()
    this.addChild(back)

    this.splashContainer = new PIXI.Container()
    this.addChild(this.splashContainer)
    this.splashContainerCenter = new PIXI.Container()
    this.splashContainer.addChild(this.splashContainerCenter)
    this.splashContainerCenter.position.set(ScaleManager.center.x, ScaleManager.center.y - 150)

    this.logo = new PIXI.Sprite(PIXI.Texture.from('preloading/logo'))
    this.splashContainerCenter.addChild(this.logo)
    this.logo.anchor.set(0.5)
    this.logo.scale.set(0.7)
    this.logo.y += 50

    this.progressContainer = new PIXI.Container()
    this.splashContainerCenter.addChild(this.progressContainer)
    this.progressBarBottom = new PIXI.Sprite(PIXI.Texture.from('preloading/progressBarBottom'))
    this.progressContainer.addChild(this.progressBarBottom)
    this.progressBarBottom.anchor.set(0.5)
    this.progressContainer.y = 200

    this.progressBarTop = new PIXI.Sprite(PIXI.Texture.from('preloading/progressBarTop'))
    this.progressContainer.addChild(this.progressBarTop)
    this.progressBarTop.anchor.set(0.5)
    this.progressBarTop.y -= 1
    this.progressBarTop.x -= ( this.progressBarTop.width )

    this.progressMask = new PIXI.Graphics()
    this.progressMask.beginFill(0xffffff)
    this.progressMask.drawRoundedRect(0, -1, this.progressBarBottom.width, this.progressBarBottom.height, 10)
    this.progressMask.endFill()
    this.progressMask.pivot.set(this.progressMask.width / 2, this.progressMask.height / 2)
    this.progressContainer.addChild(this.progressMask)

    this.progressBarTop.mask = this.progressMask

    Signals.loadingProgress.add(this.onPreloaderProgress, this)
    window.dispatchEvent(new Event('resize'))
  }

  onMobileDevice(value) {
    if(value) {
      this.logo.scale.set(1.2)
      this.splashContainerCenter.position.set(ScaleManager.center.x, ScaleManager.center.y + 50)

    } else {
      this.logo.scale.set(0.7)
      this.splashContainerCenter.position.set(ScaleManager.center.x, ScaleManager.center.y - 150)

    }
  }

  onPreloaderProgress = (progress) =>{
    this.progress = progress
   // this.progressBarTop.x = -this.progressBarTop.width + this.progress * 5.35
    this.progressBarTop.x = -(this.progressBarTop.width - 4) + this.progress * 1.62
  }

  showContinue() {

    this.showContinueSplash()
  }

  showContinueSplash() {
    // this.progressContainer.visible = false
    this.continueBtnClick()
  }

  continueBtnClick() {
   // Config.state = 'GAME'

    this.off('pointerup', this.continueBtnClick, this)
    Signals.continueBtnClick.dispatch()
    this.interactive = false
    this.destroy()
  }


}


/*

export default class SplashScreenContainer extends BaseContainer {

  constructor (data) {
    super(data)
    this.init()
  }

  init() {
    const back = new PIXI.Graphics()
    back.beginFill(0x323031)
    back.drawRect(0, 0, ScaleManager.currentSizes.total.width, ScaleManager.currentSizes.total.height)
    back.endFill()
    this.addChild(back)

    this.splashContainer = new PIXI.Container()
    this.addChild(this.splashContainer)
    this.splashContainerCenter = new PIXI.Container()
    this.splashContainer.addChild(this.splashContainerCenter)
    this.splashContainerCenter.position.set(ScaleManager.center.x, ScaleManager.center.y - 150)

    this.logo = new PIXI.Sprite(PIXI.Texture.from('preloading/logo'))
    this.splashContainerCenter.addChild(this.logo)
    this.logo.anchor.set(0.5)

    this.logo.y += 80

    this.progressContainer = new PIXI.Container()
    this.splashContainerCenter.addChild(this.progressContainer)
    this.progressBarBottom = new PIXI.Sprite(PIXI.Texture.from('preloading/progressBarBottom'))
    this.progressContainer.addChild(this.progressBarBottom)
    this.progressBarBottom.anchor.set(0.5)
    this.progressContainer.y = 200

    this.progressBarTop = new PIXI.Sprite(PIXI.Texture.from('preloading/progressBarTop'))
    this.progressContainer.addChild(this.progressBarTop)
    this.progressBarTop.anchor.set(0.5)
    this.progressBarTop.y -= 1
    this.progressBarTop.x -= (this.progressBarTop.width)

   this.progressMask = new PIXI.Graphics()
    this.progressMask.beginFill(0xffffff)
    this.progressMask.drawRoundedRect(0, -1, this.progressBarBottom.width, this.progressBarBottom.height, 10)
    this.progressMask.endFill()
    this.progressMask.pivot.set(this.progressMask.width / 2, this.progressMask.height / 2)
    this.progressContainer.addChild(this.progressMask)

    this.progressBarTop.mask = this.progressMask

    Signals.loadingProgress.add(this.onPreloaderProgress, this)
    window.dispatchEvent(new Event('resize'))
  }

  onPreloaderProgress = (progress) =>{
    this.progress = progress
    this.progressBarTop.x = -(this.progressBarTop.width - 4) + this.progress * 1.62
  }

  showContinue() {
    this.showContinueSplash()
  }

  showContinueSplash() {
      this.continueBtnClick()
  }

  continueBtnClick() {
    Config.state = 'GAME'

    Signals.continueBtnClick.dispatch()
    this.interactive = false
    this.destroy()
  }


}

 */